export default __webpack_public_path__ + "static/media/buck_controller.87a5a731.svg";